var Curriculog = Curriculog || {};
Curriculog.ProposalForm = Curriculog.ProposalForm || {};

Curriculog.ProposalForm.CheckboxField = (function ($, _, Backbone, CheckboxField) {

	CheckboxField = Curriculog.ProposalForm.Field.extend({

		/**
		 * Used to return the value of the field
		 *
		 * @returns {String} - A comma separated list of indices.
		 */
		getValue: function() {
			var mode = this.mode,
				$fields = this.getInput(),
				values = [];

			if (mode == 'edit') {
				values = $fields.filter(':checked').map(function () {
					return parseInt($(this).val(), 10);
				}).toArray();

			} else {
				values = $fields.filter('[data-selected="1"]').map(function () {
					return parseInt($(this).data('option'), 10);
				}).toArray();
			}

			return values.join(',');
		},

		/**
		 * MASSIVE TERRIBLE SHORTCUT HACK to disable the conflict dialog
		 *
		 */
		showConflict: function(data) {
			return false;
			// Oh writing this feels nasty. TP: 9214
		}

	});

	return CheckboxField;

})($, _, Backbone, Curriculog.ProposalForm.CheckboxField || {});